/**
 * CloseButton Component
 *
 * Botão para fechar o painel de artefatos
 */

import React, { memo } from 'react';

// =============================================================================
// TYPES
// =============================================================================

interface CloseButtonProps {
  onClose: () => void;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

// =============================================================================
// ICON
// =============================================================================

const CloseIcon: React.FC<{ size: number }> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      fill="currentColor"
    />
  </svg>
);

// =============================================================================
// COMPONENT
// =============================================================================

export const CloseButton: React.FC<CloseButtonProps> = memo(
  ({ onClose, className = '', size = 'md' }) => {
    const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation();
      onClose();
    };

    // Tamanhos
    const iconSizes = { sm: 14, md: 16, lg: 20 };
    const iconSize = iconSizes[size];

    // Classes de tamanho
    const sizeClasses = {
      sm: 'p-1',
      md: 'p-1.5',
      lg: 'p-2',
    };

    return (
      <button
        onClick={handleClick}
        className={`
          inline-flex items-center justify-center
          rounded-md transition-all duration-200
          text-gray-400 hover:text-white hover:bg-white/10
          focus:outline-none focus:ring-2 focus:ring-yellow-500/50
          ${sizeClasses[size]}
          ${className}
        `}
        aria-label="Fechar"
        title="Fechar (Esc)"
      >
        <CloseIcon size={iconSize} />
      </button>
    );
  }
);

CloseButton.displayName = 'CloseButton';

export default CloseButton;
